import { DecimalPipe } from '@angular/common';
import { Provider } from '@angular/core';
import { EnumToTextPipe, MgmtGroupTranslationPipe, ThousandsSeparatorPipe } from '@coin/shared/core/util-pipes';
import { FxConversionPipe } from './fx-conversion.pipe';
import { FxRatePipe } from './fx-rate.pipe';
import { IndividualMultiplierPipe } from './individual-multiplier';

// Pipes that other pipes and services inject, so they need a root provider.
export function provideInjectablePipes(): Provider[] {
  return [
    FxRatePipe,
    FxConversionPipe,
    MgmtGroupTranslationPipe,
    EnumToTextPipe,
    DecimalPipe,
    ThousandsSeparatorPipe,
    IndividualMultiplierPipe
  ];
}
